import React, { useRef } from "react";
import { motion } from "framer-motion";
import "../Styles/Choose.css";

const testimonials = [
  {
    company: "Company Name 1",
    title: "Chief Executive Officer",
    text: "It has been wonderful working with Stallform",
    rating: 4.5,
  },
  {
    company: "Company Name 2",
    title: "Chief Executive Officer",
    text: "It has been wonderful working with Stallform",
    rating: 4.0,
  },
  {
    company: "Company Name 3",
    title: "Chief Executive Officer",
    text: "It has been wonderful working with Stallform",
    rating: 3.5,
  },
  {
    company: "Company Name 4",
    title: "Chief Operating Officer",
    text: "Stahlform delivered exceptional results on our latest project.",
    rating: 5.0,
  },
  {
    company: "Company Name 5",
    title: "Project Manager",
    text: "Their customer-centric approach is truly commendable.",
    rating: 4.5,
  },
  {
    company: "Company Name 6",
    title: "Chief Executive Officer",
    text: "It has been wonderful working with Stallform",
    rating: 4.5,
  },
  {
    company: "Company Name 7",
    title: "Chief Executive Officer",
    text: "It has been wonderful working with Stallform",
    rating: 4.0,
  },
  {
    company: "Company Name 8",
    title: "Chief Executive Officer",
    text: "It has been wonderful working with Stallform",
    rating: 3.5,
  },
  {
    company: "Company Name 9",
    title: "Chief Operating Officer",
    text: "Stahlform delivered exceptional results on our latest project.",
    rating: 5.0,
  },
  {
    company: "Company Name 10",
    title: "Project Manager",
    text: "Their customer-centric approach is truly commendable.",
    rating: 4.5,
  },
];

const StarRating = ({ rating }) => {
  const fullStars = Math.floor(rating);
  const halfStar = rating % 1 !== 0;
  const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

  return (
    <div className="star-rating">
      {[...Array(fullStars)].map((_, i) => (
        <span key={i} className="star full">
          ★
        </span>
      ))}
      {halfStar && <span className="star half">★</span>}
      {[...Array(emptyStars)].map((_, i) => (
        <span key={i} className="star empty">
          ☆
        </span>
      ))}
    </div>
  );
};

const Choose = () => {
  const carouselRef = useRef(null);

  const scroll = (direction) => {
    if (carouselRef.current) {
      const cardWidth = 350;
      carouselRef.current.scrollBy({
        left: direction === "left" ? -cardWidth : cardWidth,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="testimonials-section">
      <div className="background-pattern"></div>

      <motion.div
        className="header-content"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="section-title-hi ">Voice of our Clients</h2>
        <p className="section-description">
          We pride ourselves on delivering exceptional results for our clients,
          and our reputation speaks for itself. We believe that our commitment
          to excellence, attention to detail, and customer-centricity are what
          set us apart from the competition
        </p>
      </motion.div>

      {/* Carousel */}
      <div className="carousel-outer">
        <div className="carousel-wrapper" ref={carouselRef}>
          {testimonials.map((t, i) => (
            <motion.div
              key={i}
              className="testimonial-card"
              initial={{ opacity: 0, x: 80 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ delay: i * 0.1 }}
            >
              <div className="card-header">
                <h3 className="company-name">{t.company}</h3>
                <StarRating rating={t.rating} />
              </div>
              <p className="job-title">{t.title}</p>
              <p className="testimonial-text">{t.text}</p>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Controls */}
      <div className="scroll-controls">
        <button className="scroll-arrow" onClick={() => scroll("left")}>
          &lt;
        </button>

        {/* <div className="nav-dots">
          {testimonials.map((_, i) => (
            <div key={i} className={`dot ${i === 0 ? 'active' : ''}`}></div>
          ))}
        </div> */}

        <button className="scroll-arrow" onClick={() => scroll("right")}>
          &gt;
        </button>
      </div>
    </div>
  );
};

export default Choose;
